import { Sparkles } from "lucide-react";

/**
 * Empty state shown when a surface has no real records yet.
 * Demo/mock content was removed — nothing here is ever fake data.
 */
export const ShowcaseNotice = ({ label = "Nothing here yet" }: { label?: string }) => (
  <div className="flex items-start gap-3 rounded-2xl border border-border bg-muted/30 px-4 py-4 sm:py-3">
    <Sparkles className="w-4 h-4 text-primary shrink-0 mt-0.5" />
    <p className="text-xs sm:text-sm text-muted-foreground">
      <span className="font-medium text-foreground">{label.replace(" preview", "")}</span> — no listings yet.
      Real content from creators and venues appears here as soon as it is published.
    </p>
  </div>
);

/** Kept for compatibility; sample content no longer exists so this renders nothing. */
export const SampleBadge = () => null;

export default ShowcaseNotice;
